module.exports = __webpack_public_path__ + "media/images/avatar-d2bba959.png";